module.exports = __webpack_public_path__ + "img/web_layout_svgs_mobile.d109aaac.svg";